import { newToolFilterOAuthMcp } from "../oauth.ts";

export const attioMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://attio.com/favicon.ico",
  url: "https://mcp.attio.com/mcp",
  label: "Attio",
});
